import { Component } from "react";
import { FontAwesomeIcon } from "../../../../../CommonComponents/AssetsHelper";

class InfoSection extends Component {
    render() {
        const { text } = this.props;
        return <div id="feed_note" className="alert alert-custom fade show mt-3 mb-0 bg-light rounded-0 p-3 align-items-start rounded-2">
            <div className="alert-icon py-1 f-center">
            <FontAwesomeIcon type={'solid'} icon={'circle-info'} iconClass={'fs-2 text-gray-500'} />
            <div className="text-start flex-grow-1 ms-2">
                <p className="mb-0">{text}</p>
            </div>
        </div>
        </div>
    }
}

export default InfoSection;